import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppInformationService, AuthService, GenesisUnitOfWork } from 'app/core/core.module';
import { Setting } from 'app/core/model/entity-model';
import { DxDataGridComponent } from 'devextreme-angular';
import { confirm } from 'devextreme/ui/dialog';
import _ from 'lodash';
import { BsModalService } from 'ngx-bootstrap/modal';
import { SalesEmailDialogComponent } from '../sales-email-dialog/sales-email-dialog.component';
import { SharedModule } from 'app/shared/shared.module';

@Component({
    selector: 'app-email-info',
    templateUrl: './email-info.component.html',
    styleUrls: ['./email-info.component.scss'],
    standalone: false
})
export class EmailInfoComponent implements OnInit {
    emails: any;
    settings: any;

    invoiceEmailBody: Setting;
    salesOrderEmailBody: Setting;
    purchaseOrderEmailBody: Setting;
    warrantyEmailBody: Setting;
    dealerEntryEmailBody: Setting;
    salesOrderConfirmedEmailBody: Setting;
    genesisOffice: Setting;
    achEmailSubject: Setting;
    achEmailBody: Setting;
    achPortalMessage1: Setting;
    achPortalMessage2: Setting;
    achPortalFeeMessage: Setting;
    ready = false;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
    onExporting = SharedModule.onExporting;

    constructor(protected uow: GenesisUnitOfWork, private router: Router, public auth: AuthService, private modalService: BsModalService, private appInfo: AppInformationService) {}

    async ngOnInit() {
        await this.getData();
    }

    async getData() {
        this.emails = await this.uow.getEmailAddresses();
        await this.getEmailSettings();
    }

    async getEmailSettings() {
        const settings = await this.uow.getSettings();
        this.invoiceEmailBody = _.find(settings, { name: String('InvoiceEmailBody') }) as Setting;
        this.salesOrderEmailBody = _.find(settings, { name: String('SalesOrderEmailBody') }) as Setting;
        this.purchaseOrderEmailBody = _.find(settings, { name: String('PurchaseOrderEmailBody') }) as Setting;
        this.warrantyEmailBody = _.find(settings, { name: String('WarrantyEmailBody') }) as Setting;
        this.dealerEntryEmailBody = _.find(settings, { name: String('DealerEntryEmailBody') }) as Setting;
        this.salesOrderConfirmedEmailBody = _.find(settings, { name: String('SalesOrderConfirmedEmailBody') }) as Setting;
        this.genesisOffice = _.find(settings, { name: String('GenesisOffice') }) as Setting;
        this.achEmailSubject = _.find(settings, { name: String('ACHEmailSubject') }) as Setting;
        this.achEmailBody = _.find(settings, { name: String('ACHEmailBody') }) as Setting;
        this.achPortalMessage1 = _.find(settings, { name: String('ACHPortalMessage1') }) as Setting;
        this.achPortalMessage2 = _.find(settings, { name: String('ACHPortalMessage2') }) as Setting;
        this.achPortalFeeMessage = _.find(settings, { name: String('DefaultACHFeeMessage') }) as Setting;
        this.ready = true;
    }

    async delete(selection: any) {
        const result = await (confirm(`Are you sure you want to DELETE this email address?`, `${this.appInfo.settings.company}`) as Promise<boolean>);
        if (!!result) {
            selection.forEach((row) => {
                row.deleted = new Date();
            });
            await this.uow.commit();
            await this.getData();
        }
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            }
        );
    }

    async open(newEmail?: boolean) {
        let selectedRow = null;
        if (!newEmail) selectedRow = this.dataGrid.instance.getSelectedRowsData()[0];

        const modalRef = this.modalService.show(SalesEmailDialogComponent, {
            class: 'modal-sm',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                emailAddressId: !!selectedRow ? selectedRow.id : null,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success && !!result.value) {
            }
            modalRef.hide();
            await this.getData();
        });
    }

    async rowDoubleClick(e) {
        if (!e.data || !e.data.id) return;
        this.open();
    }

    async saveEmailBody() {
        await this.uow.commit();
        await this.getEmailSettings();
    }

    async cancelEmailBody() {
        await this.uow.rollback();
        await this.getEmailSettings();
    }
}
